import styled from "styled-components";

export const Confirm = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 19;
  width: 0px;
  height: fit-content;
  margin: 10px;

  display: flex;
  flex-direction: column;

  color: var(--white);
  border-radius: 3px;
  background-color: var(--overlay);

  overflow: hidden;

  transition: width 0.4s;

  > h1 {
    font-size: 18px;
    font-weight: 500;
    margin: 10px 10px 0px;

    white-space: nowrap;
  }

  > p {
    font-size: 14px;
    white-space: nowrap;
    margin: 5px 10px;

  }

  > footer {
    margin: 0px 10px 10px;
    display: flex;
    gap: 5px;

    > button {
      flex: 1;
    }
  }

  > span {
    position: absolute;
    top: 0;
    right: 0;

    margin: 0px 5px;

    cursor: pointer;
    font-size: 20px;

    color: var(--white);

    :hover {
      color: var(--primary);
    }
  }
`;
